namespace gotoAndPlay {
    export interface IAjaxCall {
        action: string;
        stepName: string;
        productId: number;
        priced?: boolean;
        callback: Function;
    }

    export class CalculatorPage {
        playground: JQuery;
        currentStep: JQuery;
        ajax;

        stepOne: JQuery;
        stepTwo: JQuery;
        stepThree: JQuery;
        stepFour: JQuery;
        stepFive: JQuery;

        stepOneStatus: JQuery;
        stepTwoStatus: JQuery;
        stepThreeStatus: JQuery;
        stepFourStatus: JQuery;
        stepFiveStatus: JQuery;
        stepSixStatus: JQuery;

        fancybox: JQuery;
        urlGate: boolean;

        productId: number;
        productTitle: string;
        productPrice: string;
        defaultProductPrice: string;
        thinnestWallPrice: number;
        handlingMultiplier: number;
        currentFormula: string;

        discount: string;
        debug: boolean;
        language: string;
        vat: any;
        currency: string;

        confirmation: JQuery;

        surfaceWeight: number;
        surfaceSurface: number;

        wallWeight: number;
        wallSurface: number;

        wallneeded: boolean;

        calculationDone: boolean;

        hasSimplifiedChoices: boolean;
        isDiscount: boolean;

        constructor(target: JQuery) {
            this.playground = target;
            this.debug = this.GetURLParameter("debug") ? true : false;
            if (this.debug) {
                console.log("Debugger mode : ON");
                console.log("Updated - 23.11.2018");
            }
            (
                document.getElementById("calculator__form") as HTMLFormElement
            ).reset();

            this.stepOne = $("#step1");
            this.stepTwo = $("#step2");
            this.stepThree = $("#step3");
            this.stepFour = $("#step4");
            this.stepFive = $("#step5");

            this.stepOneStatus = $("#step1_status");
            this.stepTwoStatus = $("#step2_status");
            this.stepThreeStatus = $("#step3_status");
            this.stepFourStatus = $("#step4_status");
            this.stepFiveStatus = $("#step5_status");
            this.stepSixStatus = $("#step6_status");

            this.calculationDone = false;
            this.urlGate = true;
            this.confirmation = $(".js-confirmation");
            this.language = this.playground.data("langauge");
            this.handlingMultiplier = this.playground.data("handling") || 1;
            this.currency = this.playground.find("#currency").val()
                ? (this.playground.find("#currency").val() as string)
                : "€";
            this.vat = Number($("#VAT").val()) ? Number($("#VAT").val()) : 1;
            this.init();

            if (this.debug) {
                console.log("Calculator initialized", {
                    language: this.language,
                    handling: this.handlingMultiplier,
                    currency: this.currency,
                    vat: this.vat,
                });
            }
        }

        // #region SetUp
        GetURLParameter(sParam): string {
            let sPageURL = window.location.search.substring(1);
            let sURLVariables = sPageURL.split("&");
            for (let i = 0; i < sURLVariables.length; i++) {
                let sParameterName = sURLVariables[i].split("=");
                if (sParameterName[0] == sParam) {
                    return sParameterName[1];
                }
            }
        }
        init(): void {
            let object = this;
            this.confirmation.hide();

            $(function () {
                $(window).keydown(function (event) {
                    if (event.keyCode == 13) {
                        event.preventDefault();

                        return false;
                    }
                });
            });

            $(document).on("click", ".step__change", function () {
                object.changeStep($(this).siblings(".step__status"), "edit");
                $("#step-5__receipt").hide();
                $("#step6").hide();
            });

            $(document).on("click", ".step__change_summary", function () {
                let host = $("#" + $(this).data("target"));
                object.changeStep(host.find(".step__status"), "edit");

                $("#step-5__receipt").hide();
                $("#step6").hide();
            });

            // Setups for steps
            this.stepTwo.find(".js-shape-selected").hide();
            this.stepTwo.find(".js-shape-dims").html("");
            this.stepTwo.find(".js-shapes").show();

            $("#chosen_sink").hide();
            $("#chosen_faucet").hide();
            $(".js-steptwomethods").closest(".step__product-methods").hide();
            $("#chosen_faucet")
                .parent()
                .find(".step__product-methods")
                .addClass("h-hidden");
            $(".js-stove-install").hide();

            $("#step4").find("#step-4__info").hide();

            $("#step-5__receipt").hide();
            // Start status listeners
            this.stepOneStatus.change((event: JQuery.Event) => {
                this.stepHandler1(event);
            });
            this.stepTwoStatus.change((event: JQuery.Event) => {
                this.stepHandler2(event);
            });
            this.stepThreeStatus.change((event: JQuery.Event) => {
                this.stepHandler3(event);
            });
            this.stepFourStatus.change((event: JQuery.Event) => {
                this.stepHandler4(event);
            });
            this.stepFiveStatus.change((event: JQuery.Event) => {
                this.stepHandler5(event);
            });
            this.stepSixStatus.change((event: JQuery.Event) => {
                this.stepHandler6(event);
            });

            // Start Step 1
            this.changeStep(this.stepOneStatus, "started");
        }

        stepUpdated(step): void {
            let object = this;
            switch (step) {
                case "step1":
                    object.changeStep(object.stepOneStatus, "pending");
                    object.stepOne.show();
                    break;
                case "step2":
                    object.changeStep(object.stepTwoStatus, "pending");
                    object.stepTwo.show();
                    break;
                case "step3":
                    object.changeStep(object.stepThreeStatus, "started");
                    break;
                case "step4":
                    object.changeStep(object.stepFourStatus, "started");
                    break;
                case "step5":
                    object.changeStep(object.stepFiveStatus, "started");
                    break;
            }
        }

        changeStep(object, state): void {
            if (object.val() != state) {
                object.val(state).trigger("change");
            }
        }

        setCurrent(host): void {
            host.removeClass("js-done");
            host.addClass("js-current");

            $("html, body").delay(300).animate(
                {
                    scrollTop: host.offset().top,
                },
                500
            );
        }

        setDone(host): void {
            host.removeClass("js-current");
            host.addClass("js-done");
        }

        getDropdowns(host: JQuery, selector: string): Array<HTMLElement> {
            let nameMap = [];
            host.find(selector)
                .find('input[type="radio"]')
                .each(function () {
                    if (
                        $(this).closest(".multiselect-dropdown:visible")
                            .length > 0
                    ) {
                        let name = $(this).attr("name");
                        nameMap.push(name);
                    }
                });

            return nameMap;
        }

        getEmptyDropdowns(nameMap): Array<HTMLElement> {
            let errors = [];
            for (let key in nameMap) {
                if (
                    $(document).find(
                        'input[name="' + nameMap[key] + '"]:checked'
                    ).length == 0
                ) {
                    let parent = $(document)
                        .find('input[name="' + nameMap[key] + '"]')
                        .closest(".multiselect-dropdown");
                    errors.push(parent);
                }
            }

            return errors;
        }

        updateErrors(errors, host: JQuery): boolean {
            if (this.debug) {
                console.log("Updating errors ->", errors);
            }

            host.find(".js-error").removeClass("js-error");

            $(errors).each(function () {
                $(this).addClass("js-error");
            });

            let result = errors.length > 0 ? false : true;

            if (result) {
                host.removeClass("js-error");
                host.find(".js-error").removeClass("js-error");
            } else {
                host.addClass("js-error");
            }

            return result;
        }

        getProductByAjax(call: IAjaxCall): void {
            let object = this;

            object.ajax = $.post(ajaxPath, {
                action: call.action,
                productid: call.productId,
                state: call.stepName,
                name: call.stepName,
                priced: call.priced,
            });
            object.ajax.then(call.callback);
        }

        // #endregion
        // #region STEP ONE

        stepOneAjax() {
            this.getProductByAjax({
                action: "product-select",
                stepName: "step_one__",
                productId: this.productId,
                priced: true,
                callback: (result) => {
                    this.setProductPrice(
                        result.pData.product_price,
                        result.pData.product_price,
                        result.pData.product_thinnest_price
                    );
                    this.productTitle = result.name;
                    this.setSimplifiedChoices(result.hasSimplifiedChoices);
                    $("#step-one__pick").val(this.productTitle);
                    $("#current_product").html(result.data);

                    const radios: JQuery = $("#current_product").find(
                        ".multiselect-dropdown--radio"
                    );
                    if (radios.length) {
                        radios.each((index: number, el: HTMLElement) => {
                            if ($(el).find("input:not(:checked)").length == 0) {
                                $(el).find("input:checked").trigger("change");
                            }
                        });
                    }
                    this.changeStep(this.stepOneStatus, "pending");
                    $("#step-one__pick").val(this.productTitle);
                    $.fancybox.close(true);
                    $(".fancybox").fancybox({
                        beforeShow: () => {
                            console.log("beforeShow");
                        },
                        afterLoad: () => {
                            console.log("afterLoad");
                        },
                    });
                },
            });
        }

        setSimplifiedChoices(hasSimplifiedChoices): void {
            const shouldCalculatorUpdate =
                hasSimplifiedChoices !== this.hasSimplifiedChoices;
            this.hasSimplifiedChoices = hasSimplifiedChoices;

            if (shouldCalculatorUpdate) {
                const stepTwoHost = $("#step2");
                const edges = stepTwoHost.find(".edges");
                const firstEdgeChoice = edges
                    .find('input[name="step_two__edge"]')
                    .eq(0);

                const sinkModalHideMethods = $(".js-sinks-method-hide");

                const chosenSink = $("#chosen_sink");
                const sinkSelectDropdown = chosenSink.find(".step__select");
                const chosenSinksRemoveButtons =
                    chosenSink.find(".step__reset");

                if (hasSimplifiedChoices) {
                    edges.addClass("h-hidden");
                    firstEdgeChoice.prop("checked", true);

                    chosenSinksRemoveButtons.trigger("click");

                    sinkModalHideMethods.addClass("h-hidden");
                    sinkModalHideMethods.find("input:checked").trigger("click");
                } else {
                    edges.removeClass("h-hidden");
                    firstEdgeChoice.prop("checked", false);

                    chosenSinksRemoveButtons.trigger("click");

                    sinkSelectDropdown.removeClass("h-hidden");

                    sinkModalHideMethods.removeClass("h-hidden");
                }
            }
        }

        addListenerStepOneProductPick(): void {
            $(document).off("change.stepOne");
            $(document).on(
                "change.stepOne",
                ".js-product-list__item",
                (pickEvent: JQuery.Event) => {
                    this.productId = $(pickEvent.currentTarget)
                        .parent(".product-list__item")
                        .find("label")
                        .data("id");
                    this.stepOneAjax();
                }
            );
        }

        addListenerStepOneEdit(): void {
            let stepOneEditBtn = $("#step-1__edit");
            let stepOneNextBtn = $("#step-1__next");
            let host = $("#step1");

            stepOneEditBtn.off("click.stepOneEdit");
            stepOneEditBtn.on("click.stepOneEdit", () => {
                if (this.validateStepOne()) {
                    this.setStepOneDone();
                } else {
                    host.addClass("js-error");
                }
            });
        }

        setProductPrice(
            price: number,
            defaultPrice: number,
            productThinnestPrice: number
        ): void {
            this.productPrice = price.toString();
            this.thinnestWallPrice = productThinnestPrice;
            this.defaultProductPrice = defaultPrice.toString();

            if (this.productPrice != this.defaultProductPrice) {
                this.isDiscount = true;
            }

            if (this.debug) {
                console.log("Setting product price ->", {
                    price: this.productPrice,
                    defaultPrice: this.defaultProductPrice,
                    thinnestPrice: this.thinnestWallPrice,
                });
            }
        }

        setStepOneDone(): void {
            let host = $("#step1");
            let stepOneEditBtn = $("#step-1__edit");
            let stepOneNextBtn = $("#step-1__next");

            host.removeClass("js-error");
            host.removeClass("js-current");
            host.addClass("js-done");

            $(document).off("change.stepOne");
            stepOneEditBtn.off("click.stepOneEdit");
            stepOneNextBtn.off("click.stepOneNext");

            this.stepOneStatus.val("done");

            this.isDiscount = false;
            host.find(".js-price-dep-input").each((index, element) => {
                if ($(element).is(":checked")) {
                    this.setProductPrice(
                        parseFloat($(element).data("price") as string),
                        parseFloat($(element).data("default-price") as string),
                        this.thinnestWallPrice
                    );
                }
            });
        }

        addListenerStepOneNext(): void {
            let stepOneNextBtn = $("#step-1__next");

            stepOneNextBtn.off("click.stepOneNext");
            stepOneNextBtn.on("click.stepOneNext", () => {
                if (this.validateStepOne()) {
                    this.changeStep(this.stepOneStatus, "done");
                }
            });
        }

        addListenerStepOneReset(): void {
            $(document).off("click.stepOne");
            $(document).on("click.stepOne", "#step_one____reset", () => {
                this.changeStep(this.stepOneStatus, "started");
                this.productId = null;
                $("#current_product").html("");
            });
        }

        stepOneCloseListeners() {
            $(document).off("click.stepOne");
            $(document).off("change.stepOne");
            $("#step-1__edit").off("click.stepOneEdit");
            $("#step-1__next").off("click.stepOneNext");
        }

        stepHandler1(event: JQuery.Event): void {
            let host = $("#step1");
            let productSelect = host.find("#choose_product");
            let productCurrent = host.find("#current_product");
            switch ($(event.currentTarget).val()) {
                case "started":
                    this.currentStep = this.stepOneStatus;
                    this.addListenerStepOneProductPick();
                    this.addListenerStepOneNext();
                    this.setCurrent(host);
                    productSelect.show();
                    productCurrent.hide();

                    // Check if product already chosen
                    let productFromLink = this.GetURLParameter("chosen");
                    if (productFromLink && this.urlGate) {
                        this.urlGate = false;
                        this.productId = Number(productFromLink);
                        this.stepOneAjax();
                    }

                    break;
                case "pending":
                    $(".js-product-list__item").prop("checked", false);
                    this.addListenerStepOneReset();
                    this.setCurrent(host);
                    productCurrent.show();
                    break;
                case "done":
                    this.stepOneCloseListeners();
                    this.setDone(host);
                    productSelect.hide();
                    productCurrent.hide();
                    this.changeStep(this.stepTwoStatus, "started");
                    break;
                case "edit":
                    this.addListenerStepOneProductPick();
                    this.addListenerStepOneReset();
                    this.addListenerStepOneEdit();
                    this.setCurrent(host);
                    $("#step-1__next").hide();
                    $("#step-1__edit").removeClass("h-hidden");
                    productSelect.show();
                    productCurrent.show();
                    this.stepOne.show();
                    break;
            }
        }

        validateStepOne(): boolean {
            let host = $("#step1");
            let nameMap = this.getDropdowns(host, "#current_product");
            let errors = this.getEmptyDropdowns(nameMap);

            if (!this.productId) {
                errors.push($("#choose_product").get(0));
            }

            let result = this.updateErrors(errors, host);
            return result;
        }
        // #endregion
        // #region STEP TWO

        removeStepTwoListeners(): void {
            $("#step2").find(".step__shapes-item").off("click.stepTwo");
            $("#step2").find("#step-2__next").off("click.stepTwo");
            $("#step2").find(".step__shapes-item").off("click.stepTwo");
            $(document).off("click.stepTwo");
        }

        addListenerStepTwoShapePicking(): void {
            let object = this;
            let host = $("#step2");
            let dimsContainer = host.find(".js-shape-selected");
            let dims = host.find(".js-shape-dims");

            host.find(".step__shapes-item").off("click.stepTwo");
            $(document).off("click.stepTwoClose");
            host.find(".step__shapes-item").on(
                "click.stepTwo",
                function (pickeEvent) {
                    host.find(".js-dims-more").show();
                    object.currentFormula = String(
                        $(pickeEvent.currentTarget)
                            .find("input")
                            .data("formula")
                    );
                    dims.html("");

                    let image = $(pickeEvent.currentTarget)
                        .find(".js-shape-image")
                        .val() as string;
                    let title = $(pickeEvent.currentTarget)
                        .find(".js-title")
                        .html() as string;
                    let sides = $(pickeEvent.currentTarget)
                        .find(".js-shape-sides")
                        .val() as number;

                    dimsContainer.find("img").attr("src", image as string);
                    dimsContainer.find(".js-shape-title").html(title);

                    const alphabet = "abcdefghijklmnopqrstuvwxyz"
                        .split("")
                        .map((c) => c.toUpperCase());
                    let count = 0;
                    while (sides > 0) {
                        sides -= 1;
                        let field =
                            '<li class="step__product-field">' +
                            "<label>" +
                            alphabet[count] +
                            "</label>" +
                            '<div class="step__product-input" data-unit="mm">' +
                            '<input id="' +
                            alphabet[count] +
                            '_size" name="step_two__surface_size_' +
                            alphabet[count] +
                            '" type="number">' +
                            "</div>" +
                            "</li>";

                        count += 1;
                        dims.append(field);
                    }

                    dimsContainer.show();
                }
            );

            $(document).on(
                "click.stepTwoClose",
                ".js-additional_dims_close",
                function () {
                    $(this).closest(".js-step-two-additional").remove();
                }
            );
        }

        addListenerStepTwoAddDims(): void {
            let stepTwoCounter = $("#step-2__counter");
            let host = $("#step2");
            let dims = host.find(".js-shape-dims");

            $(document).off("click.stepTwo");
            $(document).on("click.stepTwo", ".js-dims-more", function () {
                let newDetail = $(".js-step-two-additional-template").clone();
                newDetail.removeClass("js-step-two-additional-template");
                newDetail.removeClass("h-hidden");
                newDetail.addClass("js-step-two-additional");
                newDetail
                    .find(".js-title")
                    .html($("#words__additional-detail-title").val() as string);
                newDetail
                    .find(".js-input-A")
                    .attr(
                        "name",
                        "step_two__additional_detail_A-" + stepTwoCounter.val()
                    );
                newDetail
                    .find(".js-input-B")
                    .attr(
                        "name",
                        "step_two__additional_detail_B-" + stepTwoCounter.val()
                    );

                stepTwoCounter.val(Number(stepTwoCounter.val()) + 1);
                dims.append(newDetail.get(0).outerHTML);
            });
        }

        stepHandler2(e): void {
            let object = this;
            let host = $("#step2");
            switch (e.currentTarget.value) {
                case "started":
                    object.setCurrent(host);
                    object.currentStep = object.stepTwoStatus;
                    object.changeStep(object.stepTwoStatus, "pending");
                    break;
                case "pending":
                    object.addListenerStepTwoShapePicking();
                    object.addListenerStepTwoAddDims();

                    host.find("#step-2__next").off("click.stepTwo");
                    host.find("#step-2__next").on("click.stepTwo", function () {
                        if (object.validateStepTwo()) {
                            object.changeStep(object.stepTwoStatus, "done");
                        }
                    });
                    break;
                case "done":
                    object.setDone(host);
                    object.changeStep(object.stepThreeStatus, "started");
                    object.removeStepTwoListeners();
                    break;
                case "edit":
                    object.changeStep(object.stepTwoStatus, "pending");
                    object.setCurrent(host);
                    object.stepTwo.show();

                    host.find("#step-2__next").hide();
                    host.find("#step-2__edit").removeClass("h-hidden");

                    host.find("#step-2__next").off("click.stepTwo");

                    host.find("#step-2__edit").off("click.stepTwo");
                    host.find("#step-2__edit").on("click.stepTwo", function () {
                        if (object.validateStepTwo()) {
                            object.setStepTwoDone();
                        }
                    });
                    break;
            }
        }

        setStepTwoDone(): void {
            let host = $("#step2");

            this.setDone(host);
            this.removeStepTwoListeners();
            this.stepTwoStatus.val("done");
        }

        validateStepTwo(): boolean {
            let host = $("#step2");
            let errors = [];

            if ($('input[name="step_two__shape"]:checked').length == 0) {
                errors.push($(".step__shapes"));
            }

            if ($('input[name="step_two__edge"]:checked').length == 0) {
                errors.push($(".edges"));
            }

            if (
                !$.isNumeric($("#edge-length").val()) ||
                parseFloat($("#edge-length").val() as string) <= 0
            ) {
                errors.push($("#edge-length"));
            }

            $(".js-shape-selected")
                .find("input")
                .each(function () {
                    if (
                        !$.isNumeric((this as HTMLInputElement).value) ||
                        parseFloat(
                            (this as HTMLInputElement).value as string
                        ) <= 0
                    ) {
                        errors.push(this);
                    }
                });

            let result = this.updateErrors(errors, host);
            return result;
        }
        // #endregion
        // #region STEP THREE

        addListenerStepThreeSinkPick(): void {
            let host = $("#step3");
            $(document).off("change.notModal");
            $(document).on(
                "change.notModal",
                'input[name="step_three__sinks"]',
                (event: JQuery.Event) => {
                    if (
                        $(event.currentTarget).attr("id") == "sink_3" ||
                        $(event.currentTarget).attr("id") == "sink_2"
                    ) {
                        $("#chosen_sink").html("");
                        $("#chosen_sink")
                            .closest(".step__product")
                            .find("#chosen_sink--more")
                            .addClass("h-hidden");
                        $("#chosen_sink").hide();
                        $(".js-steptwomethods")
                            .closest(".step__product-methods")
                            .hide();
                        $(".js-product-list__item--sinks").prop(
                            "checked",
                            false
                        );
                    }
                }
            );

            $(document).on("change.notModal", "#sink_2", () => {
                $("#chosen_sink").html("");
                $("#chosen_sink")
                    .closest(".step__product")
                    .find("#chosen_sink--more")
                    .addClass("h-hidden");
                $(".js-steptwomethods")
                    .closest(".step__product-methods")
                    .show();
            });

            $(document).on(
                "change.notModal",
                "input.js-base-price-modifier",
                (event) => {
                    const product = $(event.currentTarget).parents(
                        ".step__product:not(.js-chosen-sink-container, .js-chosen-faucet-container)"
                    );
                    const isFaucet = product.closest('.js-chosen-faucet-container').length > 0;
                    const inputSelector = isFaucet ? "input[name='step_three_faucet__']" : "input[name='step_three_sink__']";
                    
                    if (
                        !product.data("default-price") ||
                        !product.data("default-thumbnail") ||
                        !product.data("default-sku")
                    ) {
                        product.data(
                            "default-price",
                            product.find(".price").text()
                        );
                        product.data(
                            "default-thumbnail",
                            product.find(".step__product-image").attr("src")
                        );
                        product.data(
                            "default-sku",
                            product.find(inputSelector).val()
                        );
                    }

                    const optionPrice = $(event.currentTarget).data("price");
                    const customThumbnail = $(event.currentTarget).data(
                        "thumbnail"
                    );
                    const customSku = $(event.currentTarget).data("sku");
                    if (optionPrice === undefined) {
                        product
                            .find(".step__product-image")
                            .attr("src", product.data("default-thumbnail"));
                        product
                            .find(".price")
                            .text(product.data("default-price"));
                        product
                            .find(inputSelector)
                            .val(product.data("default-sku"));
                    } else {
                        product.find(".price").text(optionPrice + this.currency);

                        if (customThumbnail) {
                            product
                                .find(".step__product-image")
                                .attr("src", customThumbnail);
                        }

                        product
                            .find(inputSelector)
                            .val(
                                customSku
                                    ? product
                                          .find(".step__product-title")
                                          .html()
                                          .split("<button")[0]
                                          .trim() +
                                          " (" +
                                          customSku +
                                          ")"
                                    : product.data("default-sku")
                            );
                    }

                    if (this.debug) {
                        console.log("Base price modifier changed", {
                            event,
                            product,
                            isFaucet,
                            optionPrice,
                        });
                    }
                }
            );
        }

        addListenerStepThreeFaucetPick(): void {
            let chosenFaucet = $("#chosen_faucet");

            $(document).on(
                "change.notModal",
                'input[name="step_three__faucets"]',
                function (event: JQuery.Event) {
                    if ($(event.target).attr("id") != "faucet_1") {
                        chosenFaucet.html("");
                        chosenFaucet.hide();
                        chosenFaucet
                            .parent()
                            .find("#chosen_faucet--more")
                            .addClass("h-hidden");
                        /* $('.js-steptwomethods').closest('.step__product-methods').hide();
                    $('.js-product-list__item--faucets').prop('checked', false); */
                    }

                    if ($(event.target).attr("id") === "faucet_1") {
                        chosenFaucet
                            .parent()
                            .find(".step__product-methods")
                            .addClass("h-hidden");
                    }

                    if ($(event.target).attr("id") !== "faucet_2") {
                        chosenFaucet
                            .parent()
                            .find(".step__product-methods")
                            .addClass("h-hidden");
                    } else {
                        chosenFaucet
                            .parent()
                            .find(".step__product-methods")
                            .removeClass("h-hidden");
                    }
                }
            );
        }

        addListenerStepThreeReset(): void {
            let chosenSink = $("#chosen_sink");
            let chosenFaucet = $("#chosen_faucet");

            $(document).off("click.stepThreeNext");
            $(document).on(
                "click.stepThreeNext",
                "#state-3-1__reset",
                function (event: JQuery.Event) {
                    $(event.currentTarget).closest(".step__product").remove();
                    if (chosenSink.html() == "") {
                        $("#sink_1").prop("checked", false);
                        chosenSink
                            .closest(".step__product")
                            .find("#chosen_sink--more")
                            .addClass("h-hidden");
                    }

                    $(".js-product-list__item--sinks").prop("checked", false);
                }
            );

            $(document).on(
                "click.stepThreeNext",
                "#state-3-2__reset",
                function (event: JQuery.Event) {
                    $(event.currentTarget).closest(".step__product").remove();
                    if (chosenFaucet.html() == "") {
                        $("#faucet_1").prop("checked", false);
                        chosenFaucet
                            .closest(".step__item-col")
                            .find("#chosen_faucet--more")
                            .addClass("h-hidden");
                    }

                    $(".js-product-list__item--faucets").prop("checked", false);
                }
            );
        }

        addListenerStepThreeProductPick(): void {
            let object = this;
            let chosenSink = $("#chosen_sink");
            let chosenFaucet = $("#chosen_faucet");

            $(document).off("change.stepThreeFancy");
            $(document).on(
                "change.stepThreeFancy",
                ".js-product-list__item--sinks",
                function (sinkPick) {
                    let id = $(sinkPick.currentTarget.parentElement)
                        .find("label")
                        .data("id");
                    console.log('sinkId: ');
                    console.log(id);
                    object.ajax = $.post(ajaxPath, {
                        action: "product-select",
                        productid: id,
                        pageid: $("#current-post-id").val(),
                        state: "step_three_sink__",
                        name: "state-3-1",
                        simplified: object.hasSimplifiedChoices
                            ? true
                            : undefined,
                    });
                    object.ajax.then((result) => {
                        chosenSink.append(result.data);
                        chosenSink.show();
                        chosenSink
                            .closest(".step__product")
                            .find("#chosen_sink--more")
                            .removeClass("h-hidden");
                        $(".js-steptwomethods")
                            .closest(".step__product-methods")
                            .hide();
                        $("#sink_1").prop("checked", true);
                        $("#sink_1").trigger("change");

                        if (object.hasSimplifiedChoices) {
                            const sinkSelectDropdowns =
                                chosenSink.find(".step__select");

                            sinkSelectDropdowns.each(
                                (index: number, element: HTMLElement) => {
                                    const elementQuery = $(element);
                                    const dropdownOptions =
                                        elementQuery.find("input");

                                    if (dropdownOptions.length == 1) {
                                        elementQuery.addClass("h-hidden");
                                        dropdownOptions.eq(0).trigger("click");
                                    }
                                }
                            );
                        }
                        $.fancybox.close(true);
                        $(".js-product-list__item--sinks").prop(
                            "checked",
                            false
                        );
                    });
                }
            );

            $(document).on(
                "change.stepThreeFancy",
                ".js-product-list__item--faucets",
                function (faucetPick) {
                    let id = $(faucetPick.currentTarget.parentElement)
                        .find("label")
                        .data("id");
                    console.log('faucetId: ');
                    console.log(id);
                    
                    object.ajax = $.post(ajaxPath, {
                        action: "product-select",
                        productid: id,
                        pageid: $("#current-post-id").val(),
                        state: "step_three_faucet__",
                        name: "state-3-2",
                    });
                    object.ajax.then((result) => {
                        chosenFaucet.append(result.data);
                        chosenFaucet.show();
                        chosenFaucet
                            .closest(".step__item-col")
                            .find("#chosen_faucet--more")
                            .removeClass("h-hidden");
                        $("#faucet_1").prop("checked", true);
                        $("#faucet_1").trigger("change");
                        $.fancybox.close(true);
                        $(".js-product-list__item--faucets").prop(
                            "checked",
                            false
                        );
                    });
                }
            );
        }

        addListenerStepThreeNext(): void {
            let object = this;
            let host = $("#step3");

            host.find("#step-3__next").off("click.stepThreeNext");
            host.find("#step-3__next").on("click.stepThreeNext", function () {
                if (object.validateStepThree()) {
                    object.changeStep(object.stepThreeStatus, "done");
                }
            });
        }

        addListenerStepThreeEdit(): void {
            let object = this;
            let host = $("#step3");

            host.find("#step-3__edit").off("click.stepThreeEdit");
            host.find("#step-3__edit").on("click.stepThreeEdit", function () {
                if (object.validateStepThree()) {
                    object.setStepThreeDone();
                } else {
                    host.addClass("js-error");
                }
            });
        }

        setStepThreeDone(): void {
            let host = $("#step3");

            host.removeClass("js-error");
            this.setDone(host);
            this.stepThreeStatus.val("done");
            this.removeStepThreeListeners();
        }

        addListenerStepThreeStoves(): void {
            let stoveInst = $(".js-stove-install");

            $(".js-nrofstoves").find("input").off("change.number");
            $(".js-nrofstoves")
                .find("input")
                .on("change.number", function () {
                    if (
                        Number(
                            $(
                                $(".js-nrofstoves").find("input:checked").get(0)
                            ).val()
                        ) > 0
                    ) {
                        stoveInst.show();
                    } else {
                        stoveInst.hide();
                        $(".js-stove-install")
                            .find("input:checked")
                            .each(function () {
                                $(this).prop("checked", false);
                            });
                    }
                });
        }

        removeStepThreeListeners(): void {
            $("#step3").find("#step-3__next").off("click.stepThreeNext");
            $(document).off("change.stepThreeFancy");
            $(document).off("click.stepThreeNext");
            $(document).off("change.notModal");
        }

        stepHandler3(e): void {
            let object = this;
            let host = $("#step3");
            switch (e.currentTarget.value) {
                case "started":
                    object.setCurrent(host);
                    object.addListenerStepThreeSinkPick();
                    object.addListenerStepThreeFaucetPick();
                    object.addListenerStepThreeReset();
                    object.addListenerStepThreeProductPick();
                    object.addListenerStepThreeNext();
                    object.addListenerStepThreeStoves();
                    break;
                case "done":
                    object.setDone(host);
                    object.removeStepThreeListeners();
                    object.changeStep(object.stepFourStatus, "started");
                    break;
                case "edit":
                    object.setCurrent(host);
                    $(document).off("change.notModal");
                    $("#step-3__next").hide();
                    $("#step-3__edit").removeClass("h-hidden");
                    object.addListenerStepThreeSinkPick();
                    object.addListenerStepThreeFaucetPick();
                    object.addListenerStepThreeReset();
                    object.addListenerStepThreeProductPick();
                    object.addListenerStepThreeEdit();
                    object.addListenerStepThreeStoves();
                    break;
            }
        }

        validateStepThree() {
            let host = $("#step3");

            // Get sink dropdowns
            let sinkDropdowns = this.getDropdowns(
                host,
                ".js-chosen-sink-container"
            );

            // Get faucet dropdowns
            let faucetDropdowns = this.getDropdowns(
                host,
                ".js-chosen-faucet-container"
            );

            let dropdowns = [...sinkDropdowns, ...faucetDropdowns];
            let errors = this.getEmptyDropdowns(dropdowns);

            if (this.debug) {
                console.log("Sink dropdowns ->", sinkDropdowns);
                console.log("Faucet dropdowns ->", faucetDropdowns);
                console.log("Dropdowns ->", dropdowns);
                console.log("Errors ->", errors);
            }

            // Check main selects
            if (
                host.find('input[name="step_three__sinks"]:checked').length == 0
            ) {
                let item = $('input[name="step_three__sinks"]').closest(
                    ".step__item-col"
                );
                errors.push(item.get(0));
            }

            if (
                host.find('input[name="step_three__faucets"]:checked').length ==
                0
            ) {
                let item = $('input[name="step_three__faucets"]').closest(
                    ".step__item-col"
                );
                errors.push(item.get(0));
            }

            // Check stoves
            if (host.find(".js-nrofstoves").find("input:checked").length > 0) {
                if (
                    parseFloat(
                        host
                            .find(".js-nrofstoves")
                            .find("input:checked")
                            .val() as string
                    ) > 0
                ) {
                    if (
                        host.find(".js-stove-install").find("input:checked")
                            .length == 0
                    ) {
                        errors.push(host.find(".js-stove-install").get(0));
                    }
                }
            } else {
                errors.push(host.find(".js-nrofstoves").get(0));
            }

            let result = this.updateErrors(errors, host);

            return result;
        }

        // #endregion
        // #region STEP FOUR

        addListenerStepFourNext(): void {
            let object = this;

            $("#step-four__next").off("click.stepFourNext");
            $("#step-four__next").on("click.stepFourNext", function () {
                if (object.validateStepFour()) {
                    object.changeStep(object.stepFourStatus, "done");
                }
            });
        }

        addListenerStepFourReset(): void {
            let stepFourCounter = $("#step-4__counter");
            $(document).on(
                "click.stepFour",
                ".js-step-4__reset",
                (resetClick: JQuery.Event) => {
                    stepFourCounter.val(Number(stepFourCounter.val()) + 1);
                    $(resetClick.currentTarget)
                        .closest(".js-step-4__product-detail")
                        .remove();
                }
            );
        }

        addListenerStepFourAdd(): void {
            let host = $("#step4");
            let stepFourCounter = $("#step-4__counter");
            $(document).off("click.stepFourAdd");
            $(document).on(
                "click.stepFourAdd",
                ".js-step-4__product-more",
                (moreClick: JQuery.Event) => {
                    let hoster = $(moreClick.currentTarget).closest(
                        "#step-4__info"
                    );
                    let width = $("#wall__width").val();
                    let height = $("#wall__height").val();
                    let wallDetail =
                        '<div class="step__product-detail js-step-4__product-detail">' +
                        '<h3 class="step__product-title">' +
                        $(hoster).find("#step-4__title").val() +
                        '<button type="button" class="step__reset js-step-4__reset" title="' +
                        $(hoster).find("#step-4__remove").val() +
                        '">' +
                        $(hoster).find("#step-4__remove").val() +
                        "</button>" +
                        "</h3>" +
                        '<ul class="step__product-fields">' +
                        '<li class="step__product-field">' +
                        "<label>" +
                        width +
                        "</label>" +
                        '<div class="step__product-input" data-unit="mm">' +
                        '<input name="step_four__wall_size_' +
                        stepFourCounter.val() +
                        '__A" id="step-4__' +
                        stepFourCounter.val() +
                        '-A" class="step-4__detail js-wall-size-marker" type="number">' +
                        "</div>" +
                        "</li>" +
                        '<li class="step__product-field">' +
                        "<label>" +
                        height +
                        "</label>" +
                        '<div class="step__product-input" data-unit="mm">' +
                        '<input name="step_four__wall_size_' +
                        stepFourCounter.val() +
                        '__B" id="step-4__' +
                        stepFourCounter.val() +
                        '-B" class="step-4__detail" type="number">' +
                        "</div>" +
                        "</li>" +
                        "</ul>" +
                        "</div>";

                    stepFourCounter.val(Number(stepFourCounter.val()) + 1);
                    $(host)
                        .find("#step-4__additional-details")
                        .append(wallDetail);
                }
            );
        }

        addListenerStepFourEdit(): void {
            let object = this;

            $("#step-four__edit").off("click.stepFourEdit");
            $("#step-four__edit").on("click.stepFourEdit", function () {
                if (object.validateStepFour()) {
                    object.setStepFourDone();
                }
            });
        }

        setStepFourDone(): void {
            let host = $("#step4");

            this.setDone(host);
            this.stepFourStatus.val("done");
        }

        stepHandler4(e): void {
            let object = this;
            let host = $("#step4");
            let detail = host.find("#step-4__info");
            switch (e.currentTarget.value) {
                case "started":
                    object.currentStep = object.stepFourStatus;
                    object.setCurrent(host);

                    $("#wall_1").change(function () {
                        detail.show();
                    });
                    $("#wall_2").change(function () {
                        detail.hide();
                    });

                    object.addListenerStepFourNext();
                    object.addListenerStepFourReset();
                    object.addListenerStepFourAdd();

                    break;
                case "done":
                    object.setDone(host);
                    object.changeStep(object.stepFiveStatus, "started");
                    break;
                case "edit":
                    object.setCurrent(host);
                    $("#step-four__next").hide();
                    $("#step-four__edit").removeClass("h-hidden");

                    $("#wall_1").change(function () {
                        detail.show();
                    });
                    $("#wall_2").change(function () {
                        detail.hide();
                    });

                    object.addListenerStepFourEdit();
                    object.addListenerStepFourReset();
                    object.addListenerStepFourAdd();
                    break;
            }
        }

        validateStepFour(): boolean {
            let errors = [];
            let host = $("#step4");

            if ($('input[name="step_four__wall"]:checked').length == 0) {
                let item = $('input[name="step_four__wall"]').closest(
                    ".step__item-col"
                );
                errors.push(item.get(0));
            }

            if ($("#wall_1").is(":checked")) {
                $(".step-4__detail").each(function () {
                    if (
                        !$.isNumeric($(this).val()) ||
                        parseFloat($(this).val() as string) <= 0
                    ) {
                        errors.push(this);
                    }
                });
            }

            let result = this.updateErrors(errors, host);

            return result;
        }
        // #endregion
        // #region STEP FIVE

        addListenerStepFiveCalc(): void {
            let host: JQuery = $("#step5");
            let discountField: HTMLInputElement = $("#step-5__discount").get(
                0
            ) as HTMLInputElement;

            host.find("input").change((): void => {
                this.receiptClose();
                if (this.calculationDone) {
                    $("#step-5__calculate").trigger("click");
                }
            });

            $("#step-5__calculate").click((): void => {
                if (discountField.value === "") {
                    if (this.validateStepFive()) {
                        this.calculationDone = true;
                        this.changeStep(this.stepFiveStatus, "pending");
                    }
                } else {
                    if (this.validateStepFive()) {
                        this.validateDiscount(discountField);
                    }
                }
            });
        }

        stepHandler5(e): void {
            let object = this;
            let host = $("#step5");
            let receipt = $("#step-5__receipt");

            switch (e.currentTarget.value) {
                case "started":
                    object.setCurrent(host);
                    receipt.hide();
                    object.addListenerStepFiveCalc();
                    break;
                case "pending":
                    object.showReceipt();
                    object.changeStep(object.stepFiveStatus, "done");
                    break;
                case "done":
                    object.changeStep(object.stepSixStatus, "started");
                    break;
            }
        }

        receiptShow(): void {
            $("#step-5__receipt").show();
            $("html, body")
                .delay(500)
                .animate(
                    {
                        scrollTop: $("#step-5__receipt").offset().top,
                    },
                    500
                );
            $("#step6").show();
        }

        receiptClose(): void {
            $("#step-5__receipt").hide();
            $("#step6").hide();
        }

        getSurface() {
            let object = this;
            let stepOneImg = $("#current_product").find("img").attr("src");
            let stepOnePrice =
                parseFloat(object.productPrice) +
                this.currency +
                "/m<sup>2</sup>";
            let stepOneTitle = object.productTitle;

            return [stepOneImg, stepOnePrice, stepOneTitle, "step1"];
        }

        getSinks() {
            let sinks: any = [];
            let sinksJquery = $("#chosen_sink").find(".step__product");
            if ($("#sink_1").is(":checked")) {
                sinksJquery.each((index: number, sink: HTMLElement) => {
                    let sinkJ: JQuery = $(sink);
                    let sinkImg: string = sinkJ.find("img").attr("src");
                    let sinkTitle: string = sinkJ
                        .find(".step__product-title")
                        .clone()
                        .children()
                        .remove()
                        .end()
                        .text()
                        .trim();
                    let sinkPrice: number = parseFloat(
                        sinkJ.find(".price").text().trim()
                    );

                    let sinkInstallation = 0;
                    sinkJ
                        .find(
                            ".js-price-dep-input:not('.js-base-price-modifier')"
                        )
                        .each(function (index: number, input: HTMLElement) {
                            let item: JQuery = $(input);
                            if (item.is(":checked")) {
                                sinkInstallation = parseFloat(
                                    item.data("price")
                                );
                                sinkPrice += sinkInstallation;
                            }
                        });

                    sinks.push([
                        sinkImg,
                        sinkPrice + this.currency,
                        sinkTitle,
                        "step3",
                        "sink",
                    ]);
                });

                return sinks;
            } else if ($("#sink_2").is(":checked")) {
                let sinkInstallation: number = 0;
                $("#sinks_playground")
                    .find(".js-chosen-sink-container")
                    .find("li")
                    .each((index, item) => {
                        if ($(item).find("input").is(":checked")) {
                            if ($(item).find("input").data("price")) {
                                sinkInstallation = parseFloat(
                                    $(item).find("input").data("price")
                                );
                            } else {
                                sinkInstallation *= parseFloat(
                                    $(item).find("input").val() as string
                                );
                            }
                        }
                    });

                return [
                    [
                        "",
                        sinkInstallation + " " + this.currency,
                        false,
                        "step3",
                        "sink",
                    ],
                ];
            } else {
                return null;
            }
        }

        getFaucets() {
            let faucets: any = [];
            let faucetsJquery: JQuery =
                $("#chosen_faucet").find(".step__product");
            if ($("#faucet_1").is(":checked")) {
                faucetsJquery.each((index: number, faucet: HTMLElement) => {
                    const faucetJ = $(faucet);
                    const faucetImg: string = faucetJ.find("img").attr("src");
                    const faucetTitle: string = faucetJ
                        .find(".step__product-title")
                        .clone()
                        .children()
                        .remove()
                        .end()
                        .text()
                        .trim();
                    const faucetPrice =
                        parseFloat(faucetJ.find(".price").text().trim()) +
                        $("#faucet_2").data("holeprice");

                    faucets.push([
                        faucetImg,
                        faucetPrice + " " + this.currency,
                        faucetTitle,
                        "step3",
                        "faucet",
                    ]);
                });

                return faucets;
            } else if ($("#faucet_2").is(":checked")) {
                const price =
                    parseFloat(
                        $("#chosen_faucet")
                            .parent()
                            .find(".js-steptwoamount")
                            .find("input:checked")
                            .val() as string
                    ) * $("#faucet_2").data("holeprice");
                return [
                    ["", price + " " + this.currency, false, "step3", "faucet"],
                ];
            } else {
                return null;
            }
        }

        showReceipt(): void {
            let object = this;
            object.receiptShow();

            // Define items for check
            let items = [];

            // Surface
            let surfaceItem = object.getSurface();

            // Sinks
            let sinkPrice = 0;
            let sinkItems = object.getSinks();
            if (sinkItems) {
                sinkItems.forEach(
                    (sinkItem: []) => (sinkPrice += parseFloat(sinkItem[1]))
                );
            }

            // faucet
            let faucetPrice = 0;
            let faucetItems: [] = object.getFaucets();
            if (faucetItems) {
                faucetItems.forEach(
                    (faucetItem: []) =>
                        (faucetPrice += parseFloat(faucetItem[1]))
                );
            }

            // Stove

            let stoveInstallation = 0;
            let numberOfStoves = 0;
            $(".js-stove-install")
                .find("input")
                .each(function () {
                    if ($(this).is(":checked")) {
                        stoveInstallation = parseFloat($(this).data("price"));
                    }
                });
            $(".js-nrofstoves")
                .find("input")
                .each(function () {
                    if ($(this).is(":checked")) {
                        numberOfStoves = parseFloat($(this).data("title"));
                    }
                });

            // Formulas

            /**
             * ____B_____
             * |_________|A
             *
             * ____B_____
             * |   ______|C
             * |  |
             * A  D
             * |__|
             *
             * _______B_____
             * |  __|F|__  |
             * A |       | C
             * |_|       |_|
             *  D         E
             *
             */
            let surface = 0;
            let sizeA = $("#A_size");
            let sizeB = $("#B_size");
            let sizeC = $("#C_size");
            let sizeD = $("#D_size");
            let sizeE = $("#E_size");
            let sizeF = $("#F_size");
            let sizeG = $("#G_size");
            let sizeH = $("#H_size");
            switch (object.currentFormula) {
                case "1":
                    surface =
                        surface + Number(sizeC.val()) * Number(sizeD.val());
                case "0":
                    surface =
                        surface + Number(sizeA.val()) * Number(sizeB.val());
                    break;
                case "3":
                    surface =
                        surface + Number(sizeE.val()) * Number(sizeF.val());
                case "2":
                    surface =
                        surface +
                        Number(sizeA.val()) * Number(sizeD.val()) +
                        (Number(sizeB.val()) - Number(sizeD.val())) *
                            Number(sizeC.val());
                    break;
                case "5":
                    surface =
                        surface + Number(sizeG.val()) * Number(sizeH.val());
                case "4":
                    surface =
                        surface +
                        Number(sizeA.val()) * Number(sizeF.val()) +
                        Number(sizeD.val()) * Number(sizeC.val()) +
                        (Number(sizeB.val()) -
                            Number(sizeD.val()) -
                            Number(sizeF.val())) *
                            Number(sizeE.val());
                    break;
            }

            // Calculate surface price and weight
            this.surfaceSurface = surface * 0.000001;
            let surfacePrice =
                this.surfaceSurface * parseFloat(object.productPrice);
            let surfacePriceNotDiscounted =
                this.surfaceSurface * parseFloat(object.defaultProductPrice);

            let thickness;
            if ($(".js-thickness").length > 0) {
                $(".js-thickness")
                    .find("input:checked")
                    .each((index, element) => {
                        thickness =
                            parseFloat($(element).val() as string) / 100;
                    });
            } else {
                thickness = 0.3;
            }

            let surfaceVolume = surface * 0.0000001 * thickness;

            // Additional
            $(".js-step-two-additional").each(function () {
                let inputs = $(this).find("input");
                if (inputs[0] && inputs[1]) {
                    let A = Number($(inputs[0]).val());
                    let B = Number($(inputs[1]).val());
                    surfacePriceNotDiscounted +=
                        A *
                        B *
                        0.000001 *
                        parseFloat(object.defaultProductPrice);
                    surfacePrice +=
                        A * B * 0.000001 * parseFloat(object.productPrice);
                    surfaceVolume += A * B * 0.0000001 * thickness;
                    surface += A * B;
                }
            });

            // Add handling cost
            surfacePrice = Math.round(surfacePrice * object.handlingMultiplier);
            surfacePriceNotDiscounted = Math.round(
                surfacePriceNotDiscounted * object.handlingMultiplier
            );

            // Surface weight
            surfaceItem["weight"] = Math.round(
                surfaceVolume * Number($("#density").val())
            );
            this.surfaceWeight = surfaceItem["weight"];

            // Adding first added items
            if (surfaceItem) {
                items.push(surfaceItem);
            }
            if (sinkItems) {
                sinkItems.forEach((sinkItem: []) => items.push(sinkItem));
            }
            if (faucetItems) {
                faucetItems.forEach((faucetItem: []) => items.push(faucetItem));
            }

            // Calculating edge price
            let edgePerMM = 0.0;
            $('input[name="step_two__edge"]').each(function () {
                if ($(this).is(":checked")) {
                    edgePerMM = parseFloat($(this).data("price"));
                }
            });

            let edgePrice =
                Math.abs(Number($("#edge-length").val())) * edgePerMM;

            // Calculate wall details
            let wallPrice = 0;
            let wallPriceWithoutHandling = 0;
            let surfaceOfWall = 0;
            let wallVolume = 0;
            let longestEdges = 0;
            let wallEdgePriceTotal = 0;
            let wallEdgePrice = parseFloat($("#wall_price_mm").val() as string);
            if ($("#wall_1").is(":checked")) {
                this.wallneeded = true;
                // Calculate default piece
                surfaceOfWall =
                    (Number($("#step-4__default-A").val()) / 1000) *
                    (Number($("#step-4__default-B").val()) / 1000);
                wallPrice += Math.round(
                    surfaceOfWall *
                        object.thinnestWallPrice *
                        object.handlingMultiplier
                );
                wallPriceWithoutHandling += Math.round(
                    surfaceOfWall * object.thinnestWallPrice
                );

                // Add longest edge price
                let longestEdge =
                    Number($("#step-4__default-A").val()) >
                    Number($("#step-4__default-B").val())
                        ? Number($("#step-4__default-A").val())
                        : Number($("#step-4__default-B").val());
                wallEdgePriceTotal += longestEdge * wallEdgePrice;
                longestEdges += longestEdge;

                wallVolume = surfaceOfWall * 0.02;
                // Add additional pieces
                let nrOfInputs = $(".js-wall-size-marker").length;

                let found = 0;
                for (let i = 1; found < nrOfInputs; i++) {
                    // Calculate piece surface
                    if (
                        $("#step-4__" + i + "-A").length > 0 &&
                        $("#step-4__" + i + "-B").length > 0
                    ) {
                        found++;
                        let pieceSurface =
                            (Number($("#step-4__" + i + "-A").val()) / 1000) *
                            (Number($("#step-4__" + i + "-B").val()) / 1000);
                        surfaceOfWall += pieceSurface;

                        // Calculate piece price
                        wallPrice += Math.round(
                            pieceSurface *
                                object.thinnestWallPrice *
                                object.handlingMultiplier
                        );
                        wallPriceWithoutHandling += Math.round(
                            pieceSurface * object.thinnestWallPrice
                        );

                        let longestEdge =
                            Number($("#step-4__" + i + "-A").val()) >
                            Number($("#step-4__" + i + "-B").val())
                                ? Number($("#step-4__" + i + "-A").val())
                                : Number($("#step-4__" + i + "-B").val());
                        wallEdgePriceTotal += longestEdge * wallEdgePrice;
                        longestEdges += longestEdge;
                        // Add volume
                        wallVolume += pieceSurface * 0.02;
                    }
                }

                // Setting up wall surface item
                let wallItem;
                surfaceOfWall =
                    Math.round((surfaceOfWall + 0.00001) * 100) / 100;

                items.forEach((element) => {
                    if (element[3] == "step1") {
                        wallItem = ["", surfaceOfWall, element[2], "step4"];
                    }
                });

                // wall weight
                wallItem["weight"] = Math.round(
                    wallVolume * Number($("#density").val())
                );

                this.wallSurface = surfaceOfWall;
                this.wallWeight = wallItem["weight"];

                if (wallItem) {
                    items = [...items, wallItem];
                }
            } else {
                this.wallneeded = false;
            }

            let measuring = 0;
            let installation = 0;
            let transportation = 0;
            let location_title;
            $(".js-county-select")
                .find("input")
                .each(function () {
                    if ($(this).is(":checked")) {
                        if ($("#assembly").is(":checked")) {
                            measuring = parseFloat($(this).data("price"));
                            installation = parseFloat(
                                $(this).data("installation")
                            );
                        }

                        transportation = parseFloat(
                            $(this).data("transportation")
                        );
                        if (!transportation) {
                            transportation = 0;
                        }

                        location_title = $(this).attr("data-title");
                    }
                });

            // Display chosen products
            $("#receipt__overview").html("");
            items.forEach(function (e) {
                // If missing title skip
                if (!e[2]) {
                    return false;
                }

                let priceLine = "";
                if (e[3] == "step1") {
                    priceLine =
                        Math.round(surface * 0.000001 * 100) / 100 +
                        " m<sup>2</sup>";
                } else if (e[3] == "step4") {
                    priceLine = e[1] + " m<sup>2</sup>";
                }

                let image = "";
                if (e[0] != "") {
                    image =
                        '<img src="' +
                        e[0] +
                        '" class="calculator__price-image">';
                }
                let title = e[2];
                if (e[3] == "step1") {
                    title = $("#words__surface").val() + " " + title;
                } else if (e[3] == "step3") {
                    if (e[4] == "sink") {
                        title = $("#words__sink").val() + " " + title;
                    } else {
                        title = $("#words__faucet").val() + " " + title;
                    }
                } else if (e[3] == "step4") {
                    title = $("#words__wall").val() + " " + title;
                }

                let weight = "";
                if (e["weight"]) {
                    weight =
                        '<span class="text-small">(' +
                        e["weight"] +
                        $("#weight_unit").val() +
                        ")</span>";
                }

                $("#receipt__overview").append(
                    '<li class="calculator__price-item">' +
                        '<div class="calculator__price-product">' +
                        image +
                        '<h3 class="calculator__price-title">' +
                        title +
                        "</h3>" +
                        "</div>" +
                        '<div class="calculator__price-price">' +
                        priceLine +
                        weight +
                        "</div>" +
                        '<div class="calculator__price-edit">' +
                        '<button type="button" data-target="' +
                        e[3] +
                        '" class="step__change_summary more">' +
                        $(".step__change").get(0).innerText +
                        "</button>" +
                        "</div>" +
                        "</li>"
                );
            });

            // Check discount code
            let discountMultiplier = 1;
            let fixedDiscount = 0;
            if (object.discount && object.discount != "") {
                if (object.discount.indexOf("%") !== -1) {
                    discountMultiplier =
                        (100 - parseFloat(object.discount)) / 100;
                } else {
                    fixedDiscount = parseFloat(object.discount);
                }
            }

            // Display total
            let orgPrice =
                surfacePriceNotDiscounted +
                edgePrice +
                sinkPrice +
                faucetPrice +
                numberOfStoves * stoveInstallation +
                wallPrice +
                wallEdgePriceTotal +
                measuring +
                installation +
                transportation;
            let globalPrice =
                (surfacePrice +
                    edgePrice +
                    sinkPrice +
                    faucetPrice +
                    numberOfStoves * stoveInstallation +
                    wallPrice +
                    wallEdgePriceTotal +
                    measuring +
                    installation +
                    transportation -
                    fixedDiscount) *
                discountMultiplier;
            let globalPriceNotDiscounted =
                surfacePriceNotDiscounted +
                edgePrice +
                sinkPrice +
                faucetPrice +
                numberOfStoves * stoveInstallation +
                wallPrice +
                wallEdgePriceTotal +
                measuring +
                installation +
                transportation;

            let globalPriceVATED = globalPrice * this.vat;
            let globalPriceNotDiscountedVATED =
                globalPriceNotDiscounted * this.vat;

            orgPrice = Math.round((orgPrice + 0.00001) * 100) / 100;
            globalPrice = Math.round((globalPrice + 0.00001) * 100) / 100;
            globalPriceVATED = Math.round(
                ((globalPriceVATED + 0.00001) * 100) / 100
            );
            globalPriceNotDiscountedVATED = Math.round(
                ((globalPriceNotDiscountedVATED + 0.00001) * 100) / 100
            );

            // DEBUG
            if (this.debug) {
                console.log("\n-----------------<DEBUG>-----------------");
                console.log("Material price", this.productPrice);
                console.log("Material default price", this.defaultProductPrice);
                console.log(
                    "Material handling multiplier",
                    this.handlingMultiplier
                );
                console.log("\nSURFACE-------------");
                console.log("Surface surface area", surface * 0.000001);
                console.log("Surface price ->", surfacePrice);
                console.log(
                    "Surface default price ->",
                    surfacePriceNotDiscounted
                );
                console.log("Edge price", edgePrice);
                console.log("SURFACE TOTAL -", surfacePrice + edgePrice);
                console.log("\nADDITIONAL----------");
                console.log("Sink price", sinkPrice);
                console.log("Faucet price", faucetPrice);
                console.log("Number of stoves", numberOfStoves);
                console.log("Stove installation fee", stoveInstallation);
                console.log(
                    "Additional -",
                    sinkPrice + faucetPrice + numberOfStoves * stoveInstallation
                );
                console.log("\nWALL----------------");
                console.log("Wall surface", surfaceOfWall);
                console.log(
                    "Wall price without handling fee",
                    wallPriceWithoutHandling
                );
                console.log("Wall price with handling", wallPrice);
                console.log("Longest edges sum", longestEdges);
                console.log("Wall edge price", wallEdgePriceTotal);
                console.log("WALL TOTAL -", wallPrice + wallEdgePriceTotal);
                console.log("\nTRANSPORTATION------");
                console.log("Measuring fee", measuring);
                console.log("Installation fee", installation);
                console.log("Transportation fee", transportation);
                console.log(
                    "TRANSPORTATION TOTAL -",
                    measuring + installation + transportation
                );
                console.log("DISCOUNTS-----------");
                console.log("Fixed discount (eg 100 EUR)", fixedDiscount);
                console.log("Discount multiplier", discountMultiplier);
                console.log("\n----------------<SUMMARY>----------------");
                console.log("Raw price", orgPrice);
                console.log("Price with discount", globalPrice);
                console.log("Price with VAT", globalPriceVATED);
                console.log(
                    "Price with VAT (salePrice multiplier not used)",
                    globalPriceNotDiscountedVATED
                );
                console.log("----------------</SUMMARY>---------------");
                console.log("----------------</DEBUG>-----------------");
            }

            // Total price string
            let totalPriceString = $("#words__priceTotal").val();
            let discountedLabel = object.isDiscount
                ? " <strong>" +
                  globalPriceVATED +
                  " " +
                  this.currency +
                  "</strong>"
                : "";
            $(".calculator__price-sum").html(
                " " +
                    totalPriceString +
                    ": <strong" +
                    (object.isDiscount ? ' class="strikethrough"' : "") +
                    ">" +
                    globalPriceNotDiscountedVATED +
                    " " +
                    this.currency +
                    "</strong>" +
                    discountedLabel
            );

            if (typeof dataLayer !== "undefined") {
                dataLayer.push({
                    event: "calcCount",
                    lang: $("html").attr("lang"),
                    summ: globalPriceVATED,
                });
            }

            // additional information
            if (measuring != 0 || installation != 0) {
                $("#receipt__intsllation-transport")
                    .closest(".calculator__price-item")
                    .show();
                $("#receipt__intsllation-transport").html(location_title);

                $("#receipt__transport")
                    .closest(".calculator__price-item")
                    .hide();
                $("#receipt__measurement")
                    .closest(".calculator__price-item")
                    .show();
                $("#receipt__measurement").html(location_title);
            } else {
                $("#receipt__transport")
                    .closest(".calculator__price-item")
                    .show();
                $("#receipt__intsllation-transport")
                    .closest(".calculator__price-item")
                    .hide();
                $("#receipt__measurement")
                    .closest(".calculator__price-item")
                    .hide();
                $("#receipt__transport").html(location_title);
            }

            // Checking discount
            if (discountMultiplier !== 1 || fixedDiscount !== 0) {
                $("#receipt__total").html(
                    '<span style="color: #999999; text-decoration: line-through;"><del>' +
                        globalPriceNotDiscountedVATED +
                        " " +
                        this.currency +
                    '</del></span>&nbsp;&nbsp;&nbsp;' +
                    '<span>' +
                        globalPriceVATED +
                        " " +
                        this.currency +
                    '</span>' +
                    ' <span class="text-small" style="padding-left: 5px;">' +
                        $("#vat_info").val() +
                    "</span>"
                );
            } else {
                $("#receipt__total").html(
                    globalPriceVATED +
                        " " +
                        this.currency +
                        ' <span class="text-small" style="padding-left: 5px;">' +
                        $("#vat_info").val() +
                        "</span>"
                );
            }
        }

        validateDiscount(field: HTMLInputElement) {
            let host = $("#step5");

            this.ajax = $.post(ajaxPath, {
                action: "check-discount",
                code: field.value,
                state: "step-5",
            });
            this.ajax.then((result) => {
                let errors = [];
                if (result.data != null) {
                    this.discount = result.data;
                    this.calculationDone = true;
                    this.changeStep(this.stepFiveStatus, "pending");
                } else {
                    errors.push($(field));
                }

                this.updateErrors(errors, host);
            });
        }

        validateStepFive(): boolean {
            let errors = [];
            let host = $("#step5");

            if (
                host.find(".js-county-select").find("input:checked").length == 0
            ) {
                errors.push(host.find(".js-county-select").get(0));
            }

            let stepOne = this.validateStepOne();
            let stepTwo = this.validateStepTwo();
            let stepThree = this.validateStepThree();
            let stepFour = this.validateStepFour();
            let result = this.updateErrors(errors, host);

            if (this.debug) {
                console.log("--- <Validating all steps> ---");
                console.log("step 1", stepOne);
                console.log("step 2", stepTwo);
                console.log("step 3", stepThree);
                console.log("step 4", stepFour);
                console.log("step 5", result);
                console.log("--- </Validating all steps> ---");
            }

            result = stepOne && stepTwo && stepThree && stepFour && result;
            if (!result) {
                $("html, body").animate(
                    {
                        scrollTop: $(".js-error").first().offset().top,
                    },
                    500
                );
            } else {
                this.setStepOneDone();
                this.setStepTwoDone();
                this.setStepThreeDone();
                this.setStepFourDone();
            }

            return result;
        }
        // #endregion
        // #region STEP SIX
        stepHandler6(e): void {
            let object = this;
            let host = $("#step6");
            switch (e.currentTarget.value) {
                case "started":
                    host.addClass("js-current");
                    $(document).off("submit.form");
                    $("#calculator__submit-btn").on(
                        "click.submit",
                        function () {
                            if (object.validateStepSix()) {
                                object.changeStep(object.stepSixStatus, "done");
                            }
                        }
                    );
                    break;
                case "done":
                    $(document).on(
                        "submit.form",
                        "form",
                        (event: JQuery.Event) => {
                            event.preventDefault();
                            let formData = new FormData();
                            let data = Helpers.serializeObject(
                                $(event.currentTarget)
                            );

                            let notFormattedFormData = [];
                            for (let key in data) {
                                if (data[key].name != "step_three__sinks") {
                                    if (notFormattedFormData[data[key].name]) {
                                        notFormattedFormData[
                                            data[key].name
                                        ].push(data[key].value);
                                    } else {
                                        notFormattedFormData[data[key].name] = [
                                            data[key].value,
                                        ];
                                    }
                                }
                            }

                            for (let key in notFormattedFormData) {
                                if (notFormattedFormData.hasOwnProperty(key)) {
                                    formData.append(
                                        key,
                                        JSON.stringify(
                                            notFormattedFormData[key]
                                        )
                                    );
                                }
                            }

                            if ($('[name="client_file"]').val()) {
                                formData.append(
                                    "client_file",
                                    (
                                        $(
                                            '[name="client_file"]'
                                        )[0] as HTMLInputElement
                                    ).files[0]
                                );
                            }

                            formData.append(
                                "surfaceWeight",
                                this.surfaceWeight
                                    ? this.surfaceWeight.toString()
                                    : ""
                            );
                            formData.append(
                                "surfaceSurface",
                                this.surfaceSurface
                                    ? this.surfaceSurface.toString()
                                    : ""
                            );
                            formData.append(
                                "wallWeight",
                                this.wallWeight
                                    ? this.wallWeight.toString()
                                    : ""
                            );
                            formData.append(
                                "wallSurface",
                                this.wallSurface
                                    ? this.wallSurface.toString()
                                    : ""
                            );
                            formData.append(
                                "wallNeeded",
                                this.wallneeded ? "1" : "0"
                            );
                            formData.append("action", "submit-calculator");
                            formData.append(
                                "price",
                                $("#receipt__total").html()
                            );
                            formData.append(
                                "formulaName",
                                $('input[name="step_two__shape"]:checked').data(
                                    "formula"
                                ) as string
                            );
                            $("#calculator__submit-btn").addClass("js-loading");
                            $.ajax({
                                data: formData,
                                type: "POST",
                                url: ajaxPath,
                                processData: false,
                                contentType: false,
                            }).then((result) => {
                                $("#calculator__submit-btn").off(
                                    "click.submit"
                                );
                                $("#step5").removeClass("js-current");
                                $("#step5").addClass("js-done");
                                $("#step-5__receipt").hide();
                                host.removeClass("js-current");
                                host.addClass("js-done");
                                object.confirmation.show();
                                $("#calculator__submit-btn").removeClass(
                                    "js-loading"
                                );
                                if (typeof dataLayer !== "undefined") {
                                    dataLayer.push({
                                        event: "calcSent",
                                        lang: $("html").attr("lang"),
                                        summ: parseFloat(
                                            $("#receipt__total").html()
                                        ),
                                    });
                                }
                            });
                        }
                    );
                    $("#calculator__form").trigger("submit");
                    break;
            }
        }

        validateStepSix(): boolean {
            let errors = [];
            let host = $("#step6");

            if ($("#client-name").val() == "") {
                errors.push($("#client-name"));
            }
            if (
                $("#client-phone").val() == "" ||
                !$.isNumeric($("#client-phone").val())
            ) {
                errors.push($("#client-phone"));
            }
            if (
                $("#client-email").val() == "" ||
                !this.validateEmail($("#client-email").val())
            ) {
                errors.push($("#client-email"));
            }

            let result = this.updateErrors(errors, host);
            return result;
        }

        validateEmail(email): boolean {
            let expression =
                /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;

            return expression.test(email);
        }
    }
    // #endregion
    $(document).ready(function () {
        let $playground = $("#calculator");
        if ($playground.length > 0) {
            let productList = new CalculatorPage($playground);
        }
    });
}
